const Unauthorization = () => {
  return (
    <div>
      <h1>YOU are Unauthorization !!!</h1>
    </div>
  );
};

export default Unauthorization;
